import type { Action } from 'redux';

export interface LanguageState {
  language: string | null;
  prevLanguage: string | null;
  type: string | null;
}

interface GetInviteByTokenFulfilledAction extends Action {
  type: 'GET_INVITE_BY_TOKEN_FULFILLED';
  invite?: { language?: string };
}

interface RegisterUserFulfilledAction extends Action {
  type: 'REGISTER_USER_FULFILLED';
  language?: string;
}

interface ResetAppLangAction extends Action {
  type: 'RESET_APP_LANG';
  language?: string;
}

interface EditUserInfoFulfilledAction extends Action {
  type: 'EDIT_USER_INFO_FULFILLED';
  user: { account: { lang?: string } };
}

interface FetchAuthFulfilledAction extends Action {
  type: 'FETCH_AUTH_FULFILLED';
  user: { account: { lang?: string } };
}

type LanguageAction =
  | GetInviteByTokenFulfilledAction
  | RegisterUserFulfilledAction
  | ResetAppLangAction
  | EditUserInfoFulfilledAction
  | FetchAuthFulfilledAction;

const defaultState: LanguageState = {
  language: null,
  prevLanguage: null,
  type: null,
};

function reducer(state: LanguageState = defaultState, action: LanguageAction): LanguageState {
  switch (action.type) {
    case 'GET_INVITE_BY_TOKEN_FULFILLED': {
      const newLang = action?.invite?.language;
      if (!newLang) {
        return state;
      }
      if (state.type === 'user') {
        return {
          ...state,
        };
      }
      return {
        ...state,
        prevLanguage: state?.language || null,
        language: newLang,
        type: 'invite',
      };
    }
    case 'REGISTER_USER_FULFILLED': {
      if (!action.language) {
        return state;
      }

      const { language } = action;
      return {
        ...state,
        type: 'user',
        prevLanguage: state?.language || null,
        language,
      };
    }
    case 'RESET_APP_LANG': {
      if (!action.language) {
        return state;
      }
      const { language } = action;
      return {
        ...state,
        language,
        type: null,
      };
    }
    case 'EDIT_USER_INFO_FULFILLED': {
      if (!action.user.account.lang) {
        return state;
      }
      const newLang = action.user.account.lang;
      return {
        ...state,
        language: newLang,
        prevLanguage: state?.language || null,
        type: 'user',
      };
    }
    case 'FETCH_AUTH_FULFILLED': {
      if (!action.user.account.lang) {
        return state;
      }
      const newLang = action.user.account.lang;
      return {
        ...state,
        language: newLang,
        prevLanguage: state?.language || null,
        type: 'user',
      };
    }
    default:
      return state;
  }
}

export default reducer;
